#import "../fragments/session-user-fragment.graphql"

query GetSessionUser {
    loggedInUser {
        ...SessionUser
    }
}
